module.exports = __webpack_public_path__ + "img/health.c27d5ea6.png";